import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const ImageWithLightbox = ({ src, alt, style, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const defaultStyle = {
    cursor: 'pointer',
    transition: 'transform 0.3s ease',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    ...style
  };

  return (
    <div className="image-lightbox-container">
      <div 
        style={{ display: 'inline-block' }}
        onClick={() => setIsOpen(true)}
        title="Klik untuk memperbesar"
      >
        <img 
          src={src} 
          style={defaultStyle} 
          alt={alt || "Image"}
          className={`hover-zoom ${className || ''}`} 
        />
        <small className="text-muted mt-1 d-block">Klik gambar untuk memperbesar</small>
      </div>

      {isOpen && (
        <Lightbox
          mainSrc={src}
          onCloseRequest={() => setIsOpen(false)}
          enableZoom={true}
        />
      )}

      <style jsx>{`
        .hover-zoom:hover {
          transform: scale(1.02);
        }
      `}</style>
    </div>
  );
};

export default ImageWithLightbox;